






























import CommonBase from "@/components/CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";
import { hasRecaptchaCookie } from '@/modules/cookies';
import Api from "@/components/prelogin/Api";

@Component({
})
export default class Recaptcha extends CommonBase {
  @Inject()
  api!: Api;

  loading = true;
  needed = true;

  get rd() {
    return rd;
  }

  // Check if recaptcha cookie is set, meaning the redir to check page has been done
  get hasRecaptchaCookie(): boolean {
    return hasRecaptchaCookie();
  }

  async checkNeeded() {
    this.loading = true;
    try {
      const approved = await this.api.recaptchaApproved();
      this.needed = !approved;
      this.$emit("at-recaptcha-approved", approved);
    } finally {
      this.loading = false;
    }
  }

  created() {
    this.checkNeeded();
  }
}
